import { Components, ComponentType, MetricType } from 'interfaces';

export const getTableByComponentType = (
  components: Components[],
  types: ComponentType[],
  metricType: MetricType
): Components[] => components
  .filter((el: Components) => types.indexOf(el.componentType) !== -1 && el.metricType === metricType);
